import { type Session } from "@src/appV2/Auth/types";
import { type GetChildWorkplacesResponse } from "@src/appV2/FacilityProfile/api/useGetAllChildWorkplaces";

export interface Workplace {
  id: string;
  name: string;
}

export function getWorkplaces({
  profile,
  isParentManagedPlacementsEnabled,
  isGetChildWorkplacesSuccess,
  childWorkplaces,
}: {
  profile: Session["profile"];
  isParentManagedPlacementsEnabled: boolean;
  isGetChildWorkplacesSuccess: boolean;
  childWorkplaces: GetChildWorkplacesResponse | undefined;
}): Workplace[] {
  if (!profile) {
    return [];
  }

  if (!isParentManagedPlacementsEnabled) {
    return [
      {
        name: profile.name,
        id: profile.userId,
      },
    ];
  }

  if (!isGetChildWorkplacesSuccess) {
    return [];
  }

  return [
    {
      name: profile.name,
      id: profile.userId,
    },
    // eslint-disable-next-line unicorn/prefer-spread
  ].concat(
    childWorkplaces?.data
      .filter((workplace) => workplace.attributes.placementSettings?.managedByParentWorkplace)
      .map((facility) => ({
        name: facility.attributes.name ?? "",
        id: facility.id,
      }))
      .sort((a, b) => a.name.localeCompare(b.name)) ?? []
  );
}
